import React from "react";
import { Query } from "react-apollo";
import styled, { withTheme } from "styled-components";
import { getConnectionInfoQuery } from "cci-logic";
import { withRouter } from "cci-utility";

const Viewer = styled('iframe')`
  width: 100%;
  margin: ${props => props.theme.pagePadding}px;
  margin-top: ${props => props.theme.pageContentMarginTop}px;
  border: 0;
`;

/**
 * Previews the report within the device based on the selected parameters.
 */
const ReportPreview = ({ theme, reportName, match: { params: { options } } }) => (
  <Query query={getConnectionInfoQuery} errorPolicy="none">
    {({ error, data: { ConnectionInfo: connectionInfo } }) => (
      <Viewer
        src={`${connectionInfo.appUrl}/report/pdf?reportName=${reportName}&${options}`}
      />
    )}
  </Query>
);

export default withRouter(withTheme(ReportPreview));
